<div class="detail-container">
  <nb-card>
    <nb-card-header>
      <h5>Dienstleister Ordner Zugriff</h5>
      @if (canEdit() && !isEditing()) {
        <wr-edit-delete-button-group (edit)="startEdit()"></wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (filterForm && isInternalTenant()) {
        <form [formGroup]="filterForm">
          <div class="filter-control-group">
            <label class="label" for="tenant">Kunde</label>
            <wr-tenant-select id="tenant" formControlName="tenantId" [tenantType]="TenantTypeEnum.External"
                              [showEmptyOption]="false"></wr-tenant-select>
          </div>
        </form>
      }
      <wr-contractor-attachment-folder-view
        [externalTenantId]="selectedExternalTenantId()"
        [isEditing]="isEditing()">
      </wr-contractor-attachment-folder-view>
    </nb-card-body>
    @if (canEdit() && isEditing()) {
      <nb-card-footer>
        <button size="medium" nbButton status="primary" (click)="saveEdit()">Speichern</button>
        <button size="medium" nbButton status="basic" (click)="cancelEdit()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
